(function () {
	function initTestimonials(root) {
		var scope = root && root.querySelectorAll ? root : document;
		var sliders = Array.from(scope.querySelectorAll(".testimonials__slider"));
		if (sliders.length === 0) return;

		sliders.forEach(function (slider) {
			if (slider.dataset.swiperInit === "true") return;

			var container = slider.querySelector(".swiper");
			if (!container || typeof Swiper === "undefined") return;

			var perRow = parseInt(slider.dataset.columns, 10) || 2;
			var autoplayOn = slider.dataset.autoplay === "true";
			var speed = (parseFloat(slider.dataset.speed) || 6) * 1000;

			new Swiper(container, {
				slidesPerView: 1,
				spaceBetween: 24,
				// Discrete paging (no marquee). watchOverflow disables the
				// arrows automatically when every card already fits on screen.
				loop: false,
				watchOverflow: true,
				autoHeight: false,
				navigation: {
					nextEl: slider.querySelector(".testimonials__arrow--next"),
					prevEl: slider.querySelector(".testimonials__arrow--prev"),
				},
				autoplay: autoplayOn
					? { delay: speed, disableOnInteraction: true }
					: false,
				breakpoints: {
					750: {
						slidesPerView: perRow,
						spaceBetween: 60,
					},
				},
			});

			slider.dataset.swiperInit = "true";
		});
	}

	document.addEventListener("DOMContentLoaded", function () {
		initTestimonials(document);
	});

	// Re-initialise when a merchant adds/edits the section in the theme editor.
	document.addEventListener("shopify:section:load", function (event) {
		initTestimonials(event.target);
	});
})();
